export function pushCustomEvent(event: string): void {
  if (!window) {
    return;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event });
  } catch (e) {
    console.error(`googleTagManager - failed to push event key=${event}`);
  }
}
